import { Typography, Box, Button, Grid, Card } from "@material-ui/core";
import { QuoteLineItem } from "../../../api/Quote/QuoteLineItem";

const QuoteAddonWizardRightPreview = ({ image, name, title, addon, onRemoveAddon }: Props) => {
  const titleSection = title && (
    <Grid item md={12}>
      <Typography variant="body2">{title}</Typography>
    </Grid>
  );

  const onRemoveAddonItem = () => {
    if (addon && onRemoveAddon) {
      onRemoveAddon(addon);
    }
  };

  const removeButtonSection = addon && (
    <Box textAlign="left" ml={-1}>
      <Button size="small" onClick={onRemoveAddonItem} color="secondary" variant="text">
        Remove
      </Button>
    </Box>
  );

  return (
    <Box textAlign="center">
      <Grid container spacing={2}>
        {titleSection}
        <Grid item md={4}>
          <Card square>
            <img width="117px" height="150px" src={image} alt={name} />
          </Card>
        </Grid>
        <Grid item md={8}>
          <Box textAlign="left" fontWeight="fontWeightBold" fontSize="1 rem">
            {name}
          </Box>
          {removeButtonSection}
        </Grid>
      </Grid>
    </Box>
  );
};

export default QuoteAddonWizardRightPreview;

interface Props {
  image?: string;
  name: string;
  title?: string;
  addon?: QuoteLineItem;
  onRemoveAddon?: (addon: QuoteLineItem) => void;
}
